import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ButtonV2Module,
  IconV2Module,
  InputV2Module,
  OutputV2Module,
  SearchInputV2Module,
  SelectV2Module,
} from '@schenck/rotec-components';
import { ReactiveFormsModule } from '@angular/forms';
import { AppHeaderComponent } from './app-header/app-header.component';
import { MsalBroadcastService, MsalGuard, MsalService } from '@azure/msal-angular';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  imports: [
    CommonModule,
    SelectV2Module,
    InputV2Module,
    OutputV2Module,
    IconV2Module,
    ReactiveFormsModule,
    ButtonV2Module,
    SearchInputV2Module,
    BrowserAnimationsModule,
    BrowserModule,
    MatMenuModule,
    AppHeaderComponent,
  ],
  exports: [AppHeaderComponent],
  providers: [MsalGuard, MsalService, MsalBroadcastService],
})
export class ComponentsModule {}
